exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-type[data-v-0941654f] {\n  height: 38px !important;\n}\n", ""]);

// exports
